/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon20Solid = forwardRef('ArrowUiCornerOutUpRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9 3c0-.35.06-.687.17-1H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-3.17a2.997 2.997 0 0 1-3.466-1.12L12.12 12.12A3 3 0 1 1 7.88 7.88l2.412-2.413A2.997 2.997 0 0 1 9 3Z" }),
        React.createElement("path", { d: "M11 3a1 1 0 0 1 1-1h4.5A1.5 1.5 0 0 1 18 3.5V8a1 1 0 1 1-2 0V5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L14.586 4H12a1 1 0 0 1-1-1Z" })));
});
